const NEVER_INERTED = new Set(['SCRIPT', 'STYLE'])

// aria-modal alone is not reliably honoured by screen readers (older NVDA/JAWS with
// Chrome, VoiceOver on iOS), so a virtual cursor can still walk out of a modal overlay
// into the page behind it. Marking every sibling up the tree inert takes that page out
// of both the tab order and the accessibility tree, as the Vue 2 overlay does.
export function inertOutside(element: HTMLElement): () => void {
  const inerted: HTMLElement[] = []
  let node: HTMLElement = element
  while (node !== document.body && node.parentElement) {
    for (const sibling of Array.from(node.parentElement.children) as HTMLElement[]) {
      if (
        sibling !== node &&
        !sibling.hasAttribute('inert') &&
        !NEVER_INERTED.has(sibling.tagName)
      ) {
        sibling.setAttribute('inert', '')
        inerted.push(sibling)
      }
    }
    node = node.parentElement
  }
  return () => inerted.forEach((sibling) => sibling.removeAttribute('inert'))
}
